import { render, staticRenderFns } from "./VerifyIdentityMfa.vue?vue&type=template&id=04db0446"
import script from "./VerifyIdentityMfa.vue?vue&type=script&lang=js"
export * from "./VerifyIdentityMfa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports